import type {Snapshot} from '@platform/contracts/x';

// Presentation states only. Both viewports use the same authoritative snapshot.
export const roomTransitionPhases=['sales','preparing','one-line','two-lines','full-house','award','completed','cancelled'] as const;
export type RoomTransitionPhase=typeof roomTransitionPhases[number];
export function roomTransitionPhase(state:Snapshot):RoomTransitionPhase {
 if(state.status==='Cancelled'||state.tombala.status==='Cancelled')return 'cancelled';
 if(state.awardPause&&Date.parse(state.awardPause.untilUtc)>Date.parse(state.serverTimeUtc))return 'award';
 if(state.status==='Completed'||state.tombala.status==='Completed')return 'completed';
 if(state.status==='SalesOpen')return 'sales';
 if(state.status==='Preparing'||!state.balls.length)return 'preparing';
 return state.tombala.nextStageId==='two-lines'?'two-lines':state.tombala.nextStageId==='full-house'?'full-house':'one-line';
}
export const transitionDuration=(value:string)=>Math.min(2000,Math.max(0,parseFloat(value)*(value.endsWith('ms')?1:1000)||0));
